import { Typography } from "@circle-react-shared/uikit/Typography";

interface ListingCardProps<T> {
  emptyStateText: string;
  getItemKey: (item: T) => string;
  renderItem: (item: T, index: number) => React.ReactNode;
  resources: T[];
  title: string;
}

export const ListingCard = <T,>({
  title,
  resources,
  emptyStateText,
  renderItem,
  getItemKey,
}: ListingCardProps<T>) => (
  <div
    className="bg-primary border-primary flex w-[368px] min-w-0 flex-1 flex-col items-start gap-3 self-stretch rounded-2xl border p-4"
    style={{ boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}
  >
    <Typography.BodySm weight="font-bold" color="text-dark">
      {title}
    </Typography.BodySm>

    {resources && resources.length > 0 ? (
      <ol className="list-outside pl-5 text-sm leading-5 tracking-tight [&>li::marker]:font-bold">
        {resources.map((resource, index) => (
          <li key={getItemKey(resource)} className="!pb-0">
            {renderItem(resource, index)}
          </li>
        ))}
      </ol>
    ) : (
      <Typography.BodySm color="text-tertiary">
        {emptyStateText}
      </Typography.BodySm>
    )}
  </div>
);
